import React, { useEffect } from 'react';
import { Modal, ModalContent, ModalFooter } from "../../components/ui/Modal";
import { Button } from "../../components/ui/Button";
import { HttpRequest } from "../../util/http";
import { ModalHeader } from "reactstrap";

interface IProps {
    open: boolean;
    isFlagActive: boolean;
    flagString: string;
    postData: any;
    externalDataReference: number;
    endpoint: string;
    removedFlagConfirmationMessage: string;
    addedFlagConfirmationMessage: string;
    windowOpenerEventName: string;
    headerChildren?: React.ReactNode;
    bodyChildren?: React.ReactNode;
    footerChildren?: React.ReactNode;

    onConfirm: () => void;
    onClose: () => void;
}

const ToggleFlagConfirmationModalComponent: React.FC<IProps> = (props) => {
    const [message, setMessage] = React.useState<string>('');
    const [confirmationButtonText, setConfirmationButtonText] = React.useState<string>('');
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const flagString = props.flagString;
    const data = props.postData;
    const externalDataReference = props.externalDataReference;
    const endpoint = props.endpoint;
    const { removedFlagConfirmationMessage, addedFlagConfirmationMessage, windowOpenerEventName } = props;

    useEffect(() => {
        setMessage(props.isFlagActive ? `Do you really want to remove the ${flagString} flag from this survey?` : `Do you really want to add a ${flagString} flag to this Survey?`);
        setConfirmationButtonText(props.isFlagActive ? 'Yes, Remove Flag' : 'Yes, Add Flag');
    }, [props.isFlagActive]);

    const handleConfirm = async () => {
        setIsSubmitting(true);

        const method = 'POST';

        await HttpRequest.fetch(
            endpoint,
            { data, method }
        ).then((res: any) => {
            if (res.data.success) {
                props.onConfirm();
                Materialize.toast(`${props.isFlagActive ?
                    removedFlagConfirmationMessage :
                    addedFlagConfirmationMessage}`,
                    2500,
                    'toast-alert'
                );
                // @ts-ignore
                window.buildNoteTable(res.data.notes);
                //     emit event to window.opener to refresh the survey list
                if (window.opener) {
                    window.opener.postMessage(JSON.stringify({
                        data: windowOpenerEventName,
                        edr: externalDataReference,
                    }), location.origin);
                }
            }
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setIsSubmitting(false);
            setTimeout(() => {
                props.onClose();
            }, 250);
        });
    };

    return (
        <Modal open={props.open}>
            {props.headerChildren ? (
                <ModalHeader>
                    {props.headerChildren}
                </ModalHeader>
            ) : null}
            <ModalContent>
                {!props.headerChildren ? (
                    <header>
                        <h4>Confirm</h4>
                    </header>
                ) : null}
                {props.bodyChildren ? (
                    props.bodyChildren
                ) : null}
                {!props.bodyChildren ? (
                    <section><p>{message}</p></section>
                ) : null}
            </ModalContent>
            <ModalFooter>
                {props.footerChildren ? (
                    props.footerChildren
                ) : (
                    <div>
                        <Button type="button" color="primary" onClick={handleConfirm}>
                            {isSubmitting && <span>Submitting changes...</span>}
                            {!isSubmitting && <span>{confirmationButtonText}</span>}
                        </Button>
                        <Button type="button" color="white" onClick={props.onClose} disabled={isSubmitting}>
                            <span>Cancel</span>
                        </Button>
                    </div>
                )}
            </ModalFooter>
        </Modal>
    );
}

export default ToggleFlagConfirmationModalComponent;